import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function requiredTrimmedValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control?.value;
    if (value == null) return null;
    if (typeof value !== 'string') return null;
    return value.trim() === '' ? { required: true } : null;
  };
}
